<template>
  <div>
    <div id="nav" v-if="!mode || mode == 'main' || mode == 'combo-detail' ">
      <div class="mycontainer">
        <ul>
          <li v-for="(item, index) in categoryList" v-bind:key="item.uuid" class="" v-if="$const.NON_LOCALIZATION_CATEGORY.indexOf(item.slug) < 0 || hasDisposition"
              v-bind:class="{active: $route.name == $const.HEADER_MENU.CATEGORY && (selectedCategory && item.uuid == selectedCategory.uuid) }"
              v-on:click="changeCategory(item.slug, item)">
            <a href="javascript: void(0)" class="lg-cond">{{item.name}}</a>
          </li>
          <li v-bind:class="{active: $route.name == $const.HEADER_MENU.CATEGORY && (selectedCategory && selectedCategory.uuid == $const.COUPON_UUID)}"
              v-on:click="changeCategory('coupons')">
            <a href="javascript: void(0)" class="lg-cond">{{ $t('coupons') }}</a>
          </li>
          <li
            v-bind:class="$route.name == $const.HEADER_MENU.TOPIC || $route.name == $const.HEADER_MENU.TOPIC_DETAIL ? 'active' : ''"
            v-on:click="redirectTo($const.HEADER_MENU.TOPIC)">
            <a href="javascript: void(0)" class="lg-cond">{{ $t('footer.topics') }}</a>
          </li>
        </ul>
        <div
          v-if="$route.name == $const.HEADER_MENU.CATEGORY && (selectedCategory && selectedCategory.lower_categories)"
          class="flex">
          <div v-for="(item, index) in selectedCategory.lower_categories"
               v-bind:key="item.uuid"
               v-on:click="changeCategory(item.slug, selectedCategory, item)"
               :class="'sub_category flex-1' + (selectedSubCategory.uuid == item.uuid ? ' active' : '')">
            <span>{{item.name}}</span></div>
        </div>
      </div>
    </div>
    <div v-else-if="mode == 'footer'">
      <a href="javascript: void(0)" v-for="item in categoryList" class="clear"
         v-on:click="changeCategory(item.slug, item.uuid)"><span>{{ item.name}}</span></a>
    </div>
    <div class="container-attribute-filter" v-if="!empty(attributeList)">
      <div class="mycontainer">
        <div class="flex flex-row flex-wrap items-center">
          <div v-if="getTextInErrorMessage('FILTER-TEXT')" class="title-attr pr-10 pl-10">{{getTextInErrorMessage('FILTER-TEXT')}}</div>
          <div v-on:click="filterClick(att)" class="cursor-pointer item-attr" :class="{'active': attributeFilter && attributeFilter.indexOf(att.uuid) >=0 }"  v-for="(att, indexA) in attributeList" :key="indexA">
            <img v-bind:src="att.image.icon" alt="" width="30" v-if="att.image && att.image.icon"  class="p5"> {{att.name}}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
  .sub_category {
    cursor: pointer;
    text-align: center;
    height: 50px;
    line-height: 50px;
    font-size: 20px;
    /*font-family: SharpSansBold, Open Sans, sans-serif !important;*/
    border-top: 1px solid #e9ebee !important;
  }

  .sub_category:not(:last-child) {
    border-right: 1px solid #e9ebee !important;
  }

  .sub_category.active {
    color: #da291c;
  }

  .sub_category:hover {
    color: #da291c;
  }

  .container-attribute-filter {
    padding: 15px 10px;
    background: #fff;
    -webkit-box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.1);
    box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.1);
  }
  .container-attribute-filter .title-attr {
    font-size: 16px;
    line-height: 22px;
    color: #000000;
  }
  .container-attribute-filter .item-attr {
    background: #FFFFFF;
    padding: 5px 10px;
    margin: 5px;
    box-shadow: inset 0px -1px 0px #DFDFE3, inset -1px 0px 0px #DFDFE3, inset 0px 1px 0px #DFDFE3, inset 1px 0px 0px #DFDFE3;
    border-radius: 5px;
  }
  .container-attribute-filter .item-attr.active{
    border: 1px solid #0A8020;
  }

  @media (max-width: 500px) {
    .sub_category {
      line-height: unset;
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-align: center !important;
      -webkit-align-items: center !important;
      -ms-flex-align: center !important;
      align-items: center !important;
    }

    .sub_category span {
      width: 100%;
    }
  }
  @media (max-width: 800px) {
    .container-attribute-filter {
      position: fixed;
      float: left;
      top: 113px;
      width: 100%;
      z-index: 1001;
    }
  }
</style>
<script>
  import moment from 'moment'
  import * as types from '@/store/types'
  import {
    mapState,
    mapGetters,
    mapActions
  } from 'vuex'

  const ModalPopup  = () => import ('../popup/ModalPizza.vue')
  const ModalPopupHalf  = () => import ('../popup/ModalPizzaHalf.vue')

  export default {
    props: ['mode'],
    data: function () {
      return {
        slug: this.$route.params.slug,
        slugSub: this.$route.params.sub,
        slugParent: this.$route.params.slug,
        uuid: this.$route.params.uuid,
        sub: [],
        active: false,
        hasDisposition: false,
        currentSelectedCategory: null
      }
    },
    computed: {
      ...mapState({
        attributeList: 'attributeList',
        attributeFilter: 'attributeFilter'
      }),
      ...mapGetters({
        selectedCategoryId: 'category_uuid',
        selectedProduct: 'selectedProduct',
        selectedCartId: 'selectedCartId',
        selectedCategory: 'selectedCategory',
        selectedSubCategory: 'selectedSubCategory',
        selectedCart: 'selectedCart',
        categoryList: 'categoryList',
        selectedDisposition: 'selectedDisposition'
      })
    },
    watch: {
      selectedDisposition: function (newValue, oldValue) {
        if (newValue && !this.empty(newValue) && newValue.outletCode != '') {
          this.hasDisposition = true
        } else {
          this.hasDisposition = false
        }
      },
      '$route'(to, from) {
        this.routeChanged(to, from);
      },
      selectedCategory: function (newValue, oldValue) {
        if (this.selectedSubCategory) {
          this.currentSelectedCategory = this.selectedSubCategory;
        } else {
          this.currentSelectedCategory = this.selectedCategory;
        }
      },
      selectedSubCategory: function (newValue, oldValue) {
        if (this.selectedSubCategory) {
          this.currentSelectedCategory = this.selectedSubCategory;
        } else {
          this.currentSelectedCategory = this.selectedCategory;
        }
      },
      selectedProduct: function (newValue, oldValue) {
        this.showPopup(this.selectedProduct, this.currentSelectedCategory);
      },
      selectedCart: function (selectedCart, oldValue) {
        if (selectedCart) {
          let vm = this
          let category = getCategory(selectedCart.cartId, vm.categoryList)

          vm.getProduct(selectedCart.productUuid, selectedCart.isHalf, selectedCart.isLunch, 0, function (res, err) {
            vm.setSelectedProduct(res)
          })
        }
      }
    },
    created() {
      let vm = this
      this.routeChanged(this.$route);
    },
    mounted() {
      let vm = this
      this.hasDisposition = this.checkPosition(this)

      if (this.$route.params.sub) {
        this.slug = this.$route.params.sub;
      }

      this.$root.$on('navchanged', (slug) => {
        this.slug = slug
      });
    },
    methods: {
      ...mapActions({
        setSelectedProduct: types.SET_SELECTED_PRODUCT,
        setSelectedCategory: types.SET_SELECTED_CATEGORY,
        setAttributeFilter: types.SET_ATTRIBUTES_FILTER,
        setSelectedSubCategory: types.SET_SELECTED_SUB_CATEGORY
      }),
      filterClick (item) {
        let filter = this.attributeFilter
        if (this.attributeFilter && this.attributeFilter.indexOf(item.uuid) >= 0) {
          filter = []
          for (let i in this.attributeFilter) {
            if (this.attributeFilter[i] !== item.uuid) {
              filter.push(this.attributeFilter[i])
            }
          }
        } else {
          filter.push(item.uuid)
        }
        this.setAttributeFilter(filter)
      },
      routeChanged(to = null, from = null) {
        let vm = this;
        let subSlug = to.params.sub
        let parentSlug = to.params.slug
        let uuid = to.params.uuid

        vm.slug = to.params.slug
        vm.slugParent = vm.slug

        if (to.params.sub) {
          vm.slugSub = to.params.sub
          vm.slug = to.params.sub
        }

        if (to.name == vm.$const.HEADER_MENU.CATEGORY || to.name == vm.$const.HEADER_MENU.COMBO_DETAIL) {
          if (subSlug || uuid) {
            let isHalf = (subSlug == vm.$const.HEADER_MENU.HALF_HAlF
                || subSlug == vm.$const.HEADER_MENU.HALF_HAlF_DISCOUNT
                || subSlug == vm.$const.HEADER_MENU.HALF_HALF_30PICKUP
                || (uuid == vm.$const.HEADER_MENU.HALF_HAlF)
                || (uuid == vm.$const.HEADER_MENU.HALF_HAlF_DISCOUNT)
                || (uuid == vm.$const.HEADER_MENU.HALF_HALF_30PICKUP)
            )
            let param = uuid || subSlug;
            let onlyLunch = vm.$const.HALF_HALF_SET.NORMAL
            let discount = 0

            if (to.params.uuid == vm.$const.HEADER_MENU.LUNCH_SET) {
              onlyLunch = vm.$const.HALF_HALF_SET.LUNCH
            }
            if (subSlug == vm.$const.HEADER_MENU.HALF_HAlF_DISCOUNT || subSlug == vm.$const.HEADER_MENU.HALF_HALF_30PICKUP) {
              discount = 1
            }

            vm.getProduct(param, isHalf, onlyLunch, discount, function (res, err) {
              if (res) {
                vm.setSelectedProduct(res)
              }
            })
          }
        }
      },
      getProduct(uuid, isHalf = false, onlyLunch = false, discount = 0, callback) {
        let vm = this

        if((this.selectedSubCategory && _.lowerCase(uuid) == _.lowerCase(this.selectedSubCategory.slug)) ||
          (this.selectedCategory && _.lowerCase(uuid) == _.lowerCase(this.selectedCategory.slug))){
          return
        }

        if (isHalf) {
          let res = {};
          res.uuid = moment().format('x');
          res.isHalf = true;
          res.onlyLunch = onlyLunch
          res.discount = discount
          callback(res);
        } else {
          vm.getProductByUUID(uuid, function (res, err) {
            callback(res, err);
          })
        }
      },
      changeCategory(slug, category, subCategory = null) {
        let vm = this
        let subSlug = null;
        let selectedCategory = category;
        let selectedSubCategory = subCategory;

        if (!subCategory) {
          if(category && category.lower_categories && category.lower_categories.length){
            subSlug = category.lower_categories[0].slug
            selectedSubCategory = category.lower_categories[0]
          }
        }else{
          subSlug = selectedSubCategory.slug
        }

        if (slug == vm.$const.HEADER_MENU.COUPON) {
          selectedCategory = {
            display_type: {web: 4, mobile: 2},
            lower_categories: [],
            name: vm.$t('coupons'),
            only_lunch: 0,
            piece: 1,
            slug: slug,
            uuid: vm.$const.COUPON_UUID
          }
        }

        vm.setSelectedCategory(selectedCategory)
        vm.setSelectedSubCategory(selectedSubCategory)

        if(subSlug){
          vm.redirectToMenuPage(selectedCategory.slug, subSlug);
        }else{
          vm.redirectToMenuPage(selectedCategory.slug);
        }
      },
      showPopup(product = null) {
        let vm = this
        if (product) {
          let popup = product.isHalf ? ModalPopupHalf : ModalPopup;
          let params = {
            menu: product,
            scrollable: false,
            discount: 0,
            mfirst: {},
            msecond: {},
            extraCheese: [],
          };

          if (product.isHalf) {
            params.onlyLunch = product.onlyLunch
          }
          if (product.discount) {
            params.discount = product.discount
          }
          vm.$modal.show(popup, params, {
            class: 'modal-menu',
            clickToClose: false,
            name: 'close-modal-menu'
          }, {
            'before-open': function (event) {
              document.body.classList.add('modal-open')
            },
            'closed': function (event) {
              vm.$root.$emit('onTrackingCategory')
            },
            'opened': function (event) {
            },
          })
        }
      }
    }
  }

  function getCategory(uuid, categoryList) {
    for (let iCategory in categoryList) {
      if (categoryList[iCategory].uuid == uuid) {
        return categoryList[iCategory];
      } else {
        let lowerCategories = categoryList[iCategory].lower_categories;

        if (lowerCategories && lowerCategories.length) {
          for (let iSubCategory in lowerCategories) {
            if (lowerCategories[iSubCategory].uuid == uuid) {
              return lowerCategories[iSubCategory];
            }
          }
        }
      }
    }

    return null;
  }

</script>



// WEBPACK FOOTER //
// src/components/partials/NavCategory.vue